const state = {
  formCity: '',
  cityProps: '',
  isSocialNetwork: false,
};

const getters = {
  cityProps(localState) {
    return localState.cityProps;
  },
};

const mutations = {
  setCity(localState, newCity) {
    localState.formCity = newCity;
  },
  setCityProps(localState, cityProps) {
    localState.cityProps = cityProps;
  },
  setIsSocialNetwork(localState, isSocialNetwork) {
    localState.isSocialNetwork = isSocialNetwork;
  },
};

const actions = {
  selectCity({ commit }, formCity) {
    commit('setCity', formCity);
  },
  selectCityInfo({ commit }, cityProps) {
    commit('setCityProps', cityProps);
  },
  selectIsSocialNetwork({ commit }, isSocialNetwork) {
    commit('setIsSocialNetwork', isSocialNetwork);
  },
};
export default {
  mutations,
  actions,
  state,
  getters,
};
